import React from 'react';
import cn from 'classnames';
import { useMergeClasses, useTheme } from '../../../../../theme';
const Tabs = ({ classes, tabs, active, variant = 'line', onChange }) => {
    const { Tabs: defaultClasses } = useTheme('Shared');
    const theme = useMergeClasses(defaultClasses, classes);
    return (React.createElement("div", { className: cn(theme.tabs, theme[variant]), role: "tablist" }, tabs.map(({ label, description }, index) => (React.createElement("div", { key: `${index}-${label}`, className: theme.tab, role: "tab", "aria-selected": active === index, onClick: () => onChange(index) },
        React.createElement("span", { className: theme.label }, label),
        !!description && React.createElement("div", { className: cn(theme.description, classes === null || classes === void 0 ? void 0 : classes.description) }, description),
        React.createElement("span", { className: cn(theme.underline, classes === null || classes === void 0 ? void 0 : classes.underline) }))))));
};
export default Tabs;
